
import { useParams } from 'react-router-dom'
import { useTeacher } from '../hooks/useTeacher'
import { useEffect } from 'react';
import TeacherDetailsCards from './TeacherDetailsCards';
import Loader from 'components/Common/loader';

const TeacherDetails = () => {
  const { id } = useParams<{ id: string }>();
  const { teacher, loading, error, fetchTeacherById } = useTeacher();
  useEffect(() => {
    if (id) {
      fetchTeacherById(id);
    }
  }, []);
  if (loading) return <Loader />;
  return (
    <div className="p-2">
      <TeacherDetailsCards teacher={teacher} />
    </div>

  )
}

export default TeacherDetails